
namespace TabAurous.Finance {

    @Serenity.Decorators.registerClass()
    export class ExpenseDetailDialog extends _Ext.EditorDialogBase<ExpenseDetailRow> {
        protected getFormKey() { return ExpenseDetailForm.formKey; }
        protected getLocalTextPrefix() { return ExpenseDetailRow.localTextPrefix; }
        protected getDeletePermission() { return ExpenseDetailRow.deletePermission; }
        protected getInsertPermission() { return ExpenseDetailRow.insertPermission; }
        protected getUpdatePermission() { return ExpenseDetailRow.updatePermission; }
      
        protected form = new ExpenseDetailForm(this.idPrefix);
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }
        constructor() {
            super();
            q.setTextRightAlign(this.form.Amount);
            q.setTextRightAlign(this.form.TaxAmount);
            var taxrate = 0;
            this.form.LedgerId.changeSelect2(e => {
                var tax = OMS.AccountLedgerRow.getLookup().itemById[this.form.LedgerId.value].DefaultTDSType;
                if (tax != undefined) {
                    taxrate = OMS.TaxRow.getLookup().itemById[tax].Rate;
                    this.form.TaxId.value = OMS.TaxRow.getLookup().itemById[tax].TaxId.toString();
                }
            });
            this.form.Amount.changeSelect2(e => {
                if (taxrate != undefined) {
                    var taxamount = (taxrate * this.form.Amount.value) / 100;
                    this.form.TaxAmount.value = taxamount;
                }


            });
        }
        protected onDialogOpen() {
            super.onDialogOpen();
            var _form = (this.parentEditor.parentDialog as ExpenseDialog).form;
            if (Q.Authorization.userDefinition.exchangerate == undefined) {
                Q.alert('Please Select Currency');
                Serenity.SubDialogHelper.triggerDataChange(this);   // *** Refreshing the parent grid ***
                this.dialogClose();
                return;
            } else {

            }
            var ledgerid = (this.parentEditor.parentDialog as ExpenseDialog).form.LedgerId.value;
            if (ledgerid == null) {
                Q.alert('Please Select Party'); 
                this.dialogClose();
                return;
            }
            //if (ExpenseDetailDialog.lock) {
            //    this.element.find('.tool-buttons').attr("style", "display:none;");
            //    this.element.find('.s-DialogToolbar').attr("style", "display:none;");
            //    this.element.find('.s-Toolbar').attr("style", "display:none;");
            //    this.element.find('.clearfix').attr("style", "display:none;");

            //    q.showAndDisableField(this.form.Amount);
            //    q.showAndDisableField(this.form.LedgerId);
            //}
        }


    }
}